<!-- Notification container for new notification system -->
<app-notification-container></app-notification-container>

<!-- Main router outlet for top-level routing (login vs app-content) -->
<div [@routeAnimations]="getRouteAnimationData()">
	<router-outlet></router-outlet>
</div>

<!-- Demo modal template -->
<!-- <ng-template #demoModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Pelien demo-esittely</h4>
		<button
			type="button"
			class="btn-close"
			aria-label="Close"
			(click)="modal.dismiss()"
		></button>
	</div>
	<div class="modal-body p-0">
		<app-game-play-demo
			*ngIf="demoGameDefinition"
			[gameDefinition]="demoGameDefinition"
			[demoEvents]="demoEvents"
		></app-game-play-demo>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.close()">
			Sulje
		</button>
	</div>
</ng-template> -->
